import { api } from './nocode';

/**
 * SES PROXY INTEGRATION
 * Bypasses strict browser CORS blocks by routing emails through your PHP proxy.
 */
let lastEmailError = '';

export const getLastEmailError = () => lastEmailError;

export const sendEmail = async (to, subject, htmlBody) => {
  lastEmailError = '';

  try {
    // 1. Fetch settings unscoped to get the secure webhook secret
    let secret = '';
    try {
      const res = await api.getUnscoped('settings_gwaacademy');
      const settings = Array.isArray(res) ? res : res?.data || [];
      secret = settings.find(s => s.setting_key === 'webhook_secret' || s.key === 'webhook_secret')?.value || '';
    } catch (err) {
      console.warn("Failed to fetch settings for email secret:", err);
      lastEmailError = err?.message || 'Unable to retrieve email settings.';
    }

    if (!secret) {
      console.warn("Missing webhook secret. Cannot authenticate with email proxy.");
      lastEmailError = lastEmailError || 'Missing webhook secret. Cannot authenticate with the email proxy.';
      return false;
    }

    // 2. Call the PHP proxy script hosted on your external domain
    const proxyRes = await fetch('https://assets.emmausway.co/gwa_academy/email-sender.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        secret,
        to,
        subject,
        htmlBody
      })
    });

    // 3. Robust Error Logging
    const text = await proxyRes.text();
    try {
      const data = JSON.parse(text);
      if (!data.success) {
        console.error("PHP Proxy or AWS SES Error:", data);
        lastEmailError = data?.error || data?.message || `Email proxy request failed with status ${proxyRes.status}.`;
        return false;
      }
      return data.success === true;
    } catch (e) {
      console.error("PHP Proxy returned a non-JSON response. This usually means a PHP fatal error or server misconfiguration:", text);
      lastEmailError = text || `Email proxy returned an invalid response (HTTP ${proxyRes.status}).`;
      return false;
    }
  } catch (error) {
    console.error("Error sending email via Proxy:", error);
    lastEmailError = error?.message || 'Unable to send email via the proxy.';
    return false;
  }
};